import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { authUserSelector } from '~redux/auth/selectors/authUser';
import { useInventory } from '~view/hooks/inventory';

type InventoryProviderProps = {
  productIds: string[];
};

const InventoryProvider: React.FC<InventoryProviderProps> = ({
  productIds,
  children,
}) => {
  const user = useSelector(authUserSelector);
  const { fetchInventories, clear } = useInventory();

  useEffect(() => {
    if (!user) return;
    fetchInventories(productIds);
  }, [JSON.stringify(productIds), user]);

  useEffect(() => {
    return () => {
      clear();
    };
  }, []);

  return <>{children}</>;
};

export default InventoryProvider;
